import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    DataTable, Table, TableBody, TableCell, TableContainer, TableExpandHeader, TableExpandRow,
    TableExpandedRow, TableHead, TableHeader, TableRow, TableToolbar, TableToolbarContent,
    TableToolbarSearch
} from '@carbon/react';
import { Filter } from '@carbon/icons-react';
import DailyReportModal from "./DailyReportModal.container";
import { onGetTruckModalThunk } from "./DailyReport.actions";
import { useSorting } from "../../../modules/hooks/sorting";

const DailyReportTable = _ => {
    const dispatch = useDispatch();
    const buttonRef = useRef(null);
    const { trucks, currDate } = useSelector(state => state.daily)
    const [open, setOpen] = useState(false);

    const handleToggleModal = (currTruck) => () => {
        dispatch(onGetTruckModalThunk(currDate, currTruck));
        setOpen(true);
    };

    const headerData = [
        { header: 'Camión', key: 'truckPatent' },
        { header: 'Id dispositivo', key: 'device_id' },
        { header: 'Ciclos', key: 'ciclo', sortDirection: "DESC" },
        { header: 'Volumen Transportado (m3)', key: 'm3', sortDirection: "DESC" },
        { header: 'Tiempo efectivo (hrs)', key: 'horas_productivas', sortDirection: "DESC", isDefaultSortable: true }
    ];

    const { rows, headers } = useSorting(trucks, headerData);

    const Default = () => (
        <DataTable rows={rows} headers={headers} width="100%">
            {({
                rows,
                headers,
                getHeaderProps,
                getRowProps,
                getExpandedRowProps,
                getTableProps,
                getTableContainerProps,
                onInputChange,
                sortBy
            }) => (
                <TableContainer {...getTableContainerProps()}>
                    <TableToolbar>
                        <TableToolbarContent>
                            <TableToolbarSearch onChange={onInputChange} />
                            <Button renderIcon={Filter} kind="secondary" hasIconOnly iconDescription="Filter table" />
                        </TableToolbarContent>
                    </TableToolbar>
                    <Table {...getTableProps()} aria-label="sample table">
                        <TableHead>
                            <TableRow>
                                <TableExpandHeader aria-label="expand row" />
                                {headers.map((header) => {
                                    const { key, ...headerProps } = getHeaderProps({ header }); // Extract key separately
                                    return (
                                        <TableHeader
                                            key={header.key}
                                            {...headerProps}
                                            isSortable={header.sortDirection !== "NONE"}
                                            onClick={(_, sortState) => sortBy(sortState.sortHeaderKey)}
                                        >
                                            {header.header}
                                        </TableHeader>
                                    );
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => {
                                const { key, ...rowProps } = getRowProps({ row }); // Extract key separately
                                return (
                                    <React.Fragment key={row.id}>
                                        <TableExpandRow key={row.id} {...rowProps}>
                                            {row.cells.map((cell) => (
                                                <TableCell key={cell.id}>{cell.value}</TableCell>
                                            ))}
                                        </TableExpandRow>
                                        <TableExpandedRow colSpan={headers.length + 1} className="demo-expanded-td" {...getExpandedRowProps({ row })}>
                                            <Button onClick={handleToggleModal(row.cells[1].value)}>
                                                Ver Reporte Ciclos de Transporte
                                            </Button>
                                        </TableExpandedRow>
                                    </React.Fragment>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </DataTable>
    );

    return (
        <>
            <Default />
            <DailyReportModal button={buttonRef.current} open={open} setOpen={setOpen} />
        </>
    );
};

export default DailyReportTable;
